import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";

export default function SupplementalResponse() {
  const { documentId } = useParams<{ documentId: string }>();

  return (
    <Container className="mt-5">
      <h1>Supplemental Response</h1>
      <p className="text-muted">Document ID: {documentId}</p>
      <p>This page is under construction.</p>
    </Container>
  );
}
